import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';

import { excelStyles } from '../../components/Grid/ExcelStyles/excelStyles';
import { getAllUsers } from '../../api/users';
import LoadRowsComponent from '../../helpers/LoadRowsComponent';
import StudyLinkForeignKey from '../../components/Grid/CellRenderer/StudyLinkForeignKey';
import TotalRow from '../../components/Grid/CellRenderer/TotalRow';
import USERTYPES from '../../constants/usertypes';

const UsersGrid = ({
  usersList,
  onRowClicked,
  onDeleteClicked,
  search,
  setRefresh,
  refresh,
  sort = "",
  setSort = () => {},
  isStudyDetail = false,
}) => {
  // const [rowData, setRowData] = useState(usersList);
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState(usersList ? usersList.length : 0);

  useEffect(() => {
    if(usersList){
      setTotalRows(usersList.length)
    }
  }, [usersList]);

  useEffect(() => {
    if(refresh){
      let refreshOptions = {}
      // if adding the first row, purge for item to properly refresh
      if (gridApi.getDisplayedRowCount() === 0) refreshOptions = { purge: true };
      gridApi.refreshServerSideStore(refreshOptions);
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if(gridApi){
      //loads in more rows while scrolling
      const dataSource = {
        getRows: function(params) {
          let sortParam = "";
          if(params.request.sortModel.length !== 0){
            const sortColumn = params.request.sortModel[0].colId;
            const sortWay = params.request.sortModel[0].sort;
            if(sortWay === "desc"){
              sortParam += "-";
            }
            if(sortColumn === "username"){
              sortParam += `username`
            }
            else{
              sortParam += sortColumn;
              sortParam = sortParam.replaceAll(".", "__");
            }
          }
          if(sortParam){
            setSort(sortParam);
          }
          else{
            setSort("");
          }
          const rows = getAllUsers({limit: 100, offset: params?.request.startRow, search: search, sort: sortParam})
            .then( res => {
              setTotalRows(res.count);
              params.success({
                rowData: res.results,
                rowCount: res.count
              })
              if(res.count === 0){
                gridApi.showNoRowsOverlay();
              }
            });
        }
      };
      gridApi.setServerSideDatasource(dataSource);
    }
  }, [gridApi, search, sort]);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const cellClicked = (event) => {
    const { cellRenderer } = event.colDef;
    if (cellRenderer !== "removeRow") {
      onRowClicked(event.data);
    }
  };

  const deleteRow = (itemId) => {
    onDeleteClicked(itemId);
  };

  const onFilterChanged = () => {
    if (gridApi) {
      const displayedRowCount = gridApi.getDisplayedRowCount();
      setTotalRows(displayedRowCount);
    }
  };

  const getUserType = params => {
    return USERTYPES[params.data.usertype]
  }

  const gridOptions = {
    columnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        flex: '1',
      },
      {
        headerName: 'Username',
        field: 'username',
        flex: '1',
      },{
        headerName: 'email',
        field: 'email',
        flex: '2',
      },
      {
        headerName: 'Type',
        field: 'usertype',
        valueGetter: getUserType,
        flex: '1',
      },
      {
        headerName: 'Last Login',
        field: 'last_login',
        flex: '1',
      },
      {
        headerName: "",
        width: 40,
        cellRenderer: "removeRow",
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    excelStyles,
    frameworkComponents: {
      studyLink: StudyLinkForeignKey,
      removeRow: ({ data }) => {
        const id = data?.id;
        return (
          <i
            className="fal fa-trash-alt"
            style={{ color: "red" }}
            onClick={() => deleteRow(id)}
          ></i>
        );
      },
      LoadRowsComponent: LoadRowsComponent,
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  };

  return (
    <Container className="ag-theme-balham">
      { isStudyDetail
        ?
        <AgGridReact
          onGridReady={onGridReady}
          gridOptions={gridOptions}
          onCellClicked={event => cellClicked(event)}
          onFilterChanged={onFilterChanged}
          rowData={usersList}
        ></AgGridReact>
        :
        <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        onCellClicked={event => cellClicked(event)}
        onFilterChanged={onFilterChanged}
        // rowData={rowData}
        rowModelType={'serverSide'}
        serverSideStoreType={'partial'}
        cacheBlockSize={100}
      ></AgGridReact>

      }
      <TotalRow count={totalRows} />
    </Container>
  );
};

export default UsersGrid;

const Container = styled.div`
flex: 1 1 auto;
padding-bottom: 20px;
`
